export function CaseStudy() {
  return (
    <section id="case-study" className="case-study" aria-labelledby="case-study-heading">
      <h2 id="case-study-heading">Caso de estudio</h2>
      <ol className="case-study__list">
        <li>
          <strong>Problema:</strong> las MCP Apps necesitan estados de permiso, confirmación,
          progreso, resultado y error que sean comprensibles y reutilizables.
        </li>
        <li>
          <strong>Restricción:</strong> demostrarlo sin VPS, sin datos privados y sin
          dependencia permanente de un tercero.
        </li>
        <li>
          <strong>Decisión:</strong> aplicación estática — TypeScript en el navegador,
          procesamiento en Web Worker y persistencia local opcional. Sin backend público.
        </li>
        <li>
          <strong>Prueba:</strong> acción pública, fixtures adversariales, contratos JSON
          Schema y una suite reproducible (unitarias, contrato, integración, E2E).
        </li>
        <li>
          <strong>Resultado:</strong> solo se publican métricas obtenidas después de pruebas
          reales; nada inventado.
        </li>
      </ol>
      <p className="case-study__links">
        <a href="https://github.com/Aredex/mcp-app-ui-kit">Repositorio en GitHub</a> ·{" "}
        <a href="https://github.com/Aredex/mcp-app-ui-kit/blob/main/13-presentacion-portafolio.md">
          Presentación de portafolio
        </a>
      </p>
    </section>
  );
}
